import React from 'react'
import Layout from 'antd/lib/layout'
import Sider from '@components/Navigation'
import Header from '@components/Layouts/Header'
import styles from './index.scss'

function DashboardLayout(props) {
    const { children } = props

    return (
        <Layout className={styles['dashboard-layout']} id="dashboard-layout">
            <Sider />
            <Layout>
                <Header layoutMode="dashboard" />
                <Layout.Content className={styles['dashboard-layout__content']}>{children}</Layout.Content>
            </Layout>
        </Layout>
    )
}

export default DashboardLayout
